var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 109.2 28.8",
    style: {
      enableBackground: "new 0 0 109.2 28.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8,28.4h-5.3l-4.3-11.5H5v11.5H0v-28h12.1c3.4,0,5.9,0.8,7.4,2.3s2.4,3.5,2.4,5.9c0,3.6-1.7,6.1-5,7.4L21.8,28.4z  M5,12.9h6.3c1.8,0,3.2-0.4,4.1-1.1c0.9-0.7,1.3-1.8,1.3-3.2c0-1.2-0.4-2.2-1.3-3c-0.9-0.8-2.2-1.2-3.7-1.2H5V12.9z M32,28.4h-5v-28 h5V28.4z M59.4,14.1v14.3h-2.2l-1.5-3.8c-1.6,2.8-4.1,4.2-7.6,4.2c-3.8,0-6.7-1.4-8.5-4.3s-2.8-6.3-2.8-10.1c0-4,1-7.4,3.1-10.2 s5-4.2,8.8-4.2c2.8,0,5.1,0.8,7,2.5s3,3.7,3.4,6.1l-4.4,0.8c-0.8-3.4-2.8-5.1-5.9-5.1c-2,0-3.6,0.8-4.9,2.4S42,10.8,42,14.1 c0,7.1,2.2,10.6,6.6,10.6c1.7,0,3.1-0.6,4.3-1.8s1.7-2.8,1.7-4.7h-5.8v-4.1C48.8,14.1,59.4,14.1,59.4,14.1z M85.9,28.4h-5V16.2H70.1 v12.2h-5v-28h5v11.5h10.7V0.4h5L85.9,28.4L85.9,28.4z M101.8,28.4h-5.4V4.7H89V0.4h20.2v4.3h-7.4V28.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/R.15cbd071b42dff563a376db20746fd65.svg";
export { ForwardRef as ReactComponent };